import styled from "@emotion/styled"
import React from "react"
import Button from "../Button/button"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"

import "./table.scss"

const DynamicTable = props => {
  const T = styled(Table)`
    thead th,
    tbody td {
      width: calc(
        100% / ${props.table_rows[0].table_row.table_row_items.length + 1}
      );
    }

    td {
      &:after {
        content: "";
        width: 15px;
        height: 15px;
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        margin-left: 5px;
      }

      &.green {
        &:after {
          background: #5ead00;
        }
      }

      &.yellow {
        &:after {
          background: #f2b700;
        }
      }

      &.red {
        &:after {
          background: #d32f2f;
        }
      }
    }

    @media screen and (max-width: 991px) {
      table,
      thead,
      tbody,
      th,
      td,
      tr {
        display: block;
      }

      thead th,
      tbody td {
        width: 100%;
      }

      thead tr {
        position: absolute;
        top: -9999px;
        left: -9999px;
        border-bottom: 2px solid #333;
      }

      tbody tr {
        border-top: 1px solid #000;
        border-bottom: 1px solid #000;
        padding: 8px 0;
      }

      td.pivoted {
        padding: 8px 0;
        border: none !important;
        position: relative;
        text-align: left !important;
        white-space: pre-wrap;
        overflow-wrap: break-word;

        &:last-child {
          .tdBefore {
            &:after {
              display: none;
            }
          }
        }
      }

      td .tdBefore {
        display: inline-block;
        left: 1rem;
        white-space: pre-wrap;
        overflow-wrap: break-word;
        text-align: left !important;
        font-weight: 600;
      }
    }

    ${props.table_rows[0].table_row.button.length !== 0
      ? `td {
        padding: 10px 5px;

      &:last-child {
        text-align: right;
      }
    }`
      : `td {
      padding: 20px 5px;
    }
  }`}
  `

  return (
    <div className="table">
      <div className="container">
        {props.headline !== "no headline" && (
          <div className="table__headline">
            {props.headline_image && <img src={props.headline_image.url} />}
            {props.headline_image && props.headline_text && (
              <h4 className="table__headline-gap">-</h4>
            )}
            {props.headline_text && (
              <h4 className="headline">{props.headline_text}</h4>
            )}
          </div>
        )}
        <T>
          {props.table_headers.length !== 0 && (
            <Thead>
              <Tr>
                {props.table_headers.map((header, index) => (
                  <Th key={index}>{header.table_header.header + " "}</Th>
                ))}
                {props.table_rows[0].table_row.button.length !== 0 && <Th></Th>}
              </Tr>
            </Thead>
          )}
          <Tbody>
            {props.table_rows.map((row, index) => (
              <Tr key={index}>
                {row.table_row.table_row_items.map((item, index) => (
                  <Td
                    key={index}
                    className={
                      item.table_row_item.status_code !== "no status" &&
                      item.table_row_item.status_code
                    }
                  >
                    {item.table_row_item.item}
                  </Td>
                ))}
                {row.table_row.button.length !== 0 && (
                  <Td>
                    <Button
                      button_text={row.table_row.button[0].button_text}
                      button_type={row.table_row.button[0].button_type}
                      button_color={row.table_row.button[0].button_color}
                      button_link={row.table_row.button[0].button_link.href}
                      text_color={row.table_row.button[0].text_color}
                    />
                  </Td>
                )}
              </Tr>
            ))}
          </Tbody>
        </T>
      </div>
    </div>
  )
}

export default DynamicTable
